import { LoadableRoute } from 'routes/utils/loadable';

export const HotlistContainer = LoadableRoute({
  loader: () => import(/* webpackChunkName: "Hotlist/Root" */ './Hotlist'),
});
